export const profileIndexEnUS = {
  profile: 'Profile',
}

export const profileIndexEsMX = {
  profile: 'Perfil',
}
